import React from 'react';
import moment from 'moment';

import { Card } from 'react-bootstrap';
import { Chart, CommonSeriesSettings, Series, Export, ArgumentAxis, Margin, Legend, Tooltip, Grid, Label } from 'devextreme-react/chart';

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { renderFullScreen } from '../helpers/utils';

const axisTitles = [
    { value: 'count', name: 'Active Users' },
];

export const updateUsersInstance = () => {
    window.lineChartHistoricUsers.loadData();
}

export const updateUsersRange = () => {
  window.lineChartHistoricUsers.loadData();
}

class lineChartHistoricUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instanceNames: [],
            dataSource: '',
            getData: ''
        };
        window.lineChartHistoricUsers = this;
    }

    async componentDidMount() {
        await this.loadData();
    }

    updateData = () => {
        let results = [];
        this.state.getData.forEach((item) => {
            if(item.instance === global.config.dashboard.selectedInstance) {
                item.reportDate = moment(item.reportDate).format("DD/MM/YYYY")
                results.push(item);
            }
        })
        this.setState({ dataSource: results });
    }

    loadData = async () => { //Adjust in regard to start date and end date
        this.setState({ getData: [] });
        let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByInstanceRangeDaily", global.config.dashboard.range)
        let instanceNames = [];

        if(resp) {
          await resp.forEach((item) => { 
            if(instanceNames.indexOf(item.instance) > -1) {} 
            else {
                instanceNames.push(item.instance)
            }
          });
  
          this.setState({getData: resp, instanceNames: instanceNames}, () => {
            this.updateData();
          });
        }
    }

  render() {
    if(this.state.getData !== null) {
      return (
        <Card className="rounded-4">
          <Card.Body>
          <Card.Title>
              Historic Users ({global.config.dashboard.range} Days)
              <div className='float-end'>
                  <span className="fullscreen-link" onClick={() => {renderFullScreen("#lineChartUsers")}}>Full Screen</span>
              </div>
          </Card.Title>
          <Card.Subtitle>
              Number of Active User Logins by Day for the selected instance
          </Card.Subtitle>
          <Chart
            id="lineChartUsers"
            palette="Violet"
            dataSource={this.state.dataSource}
            title={global.config.dashboard.selectedInstance}
          >
            <CommonSeriesSettings
              argumentField="reportDate"
              type="line"
            />
            {
              axisTitles.map((item) => <Series
                key={item.value}
                valueField={item.value}
                name={item.name} />)
            }
            <Margin bottom={20} />
            <Tooltip
                enabled={true}
                location="edge"
                customizeTooltip={this.customizeTooltip}
                zIndex={10000}
            />
            <ArgumentAxis
              valueMarginsEnabled={false}
              discreteAxisDivisionMode="crossLabels"
            >
              <Grid visible={true} />
              <Label
                  wordWrap="break"
                  overlappingBehavior={"rotate"}
              />
            </ArgumentAxis>
            <Legend
              visible={false}
            />
            <Export enabled={true} />
          </Chart>
          </Card.Body>
        </Card>
      );
    }
  }

  customizeTooltip(arg) {
        return {
            text: `${arg.argumentText} \n ${arg.point.data.instance} - Sign-Ins: ${arg.valueText}`,
        }
    }
}

export default lineChartHistoricUsers;
